import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Spin, Select } from "antd";
import axios from "axios";
import * as XLSX from "xlsx";
import { AuthContext } from "../../context/AuthContext";
import { DownloadOutlined } from "@ant-design/icons";

const { Option } = Select;

export default function DepartmentWisePayroll() {
    const { authData, backUrl } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [organizations, setOrganizations] = useState([]);
    const [organisationId, setOrganisationId] = useState("1");

    const [month, setMonth] = useState("11");
    const [year, setYear] = useState("2025");

    useEffect(() => {
        fetchOrganizations();
    }, []);

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Failed to load organisations:", err);
        }
    };

    // Fetch Department Salary Report
    const fetchData = async () => {
        if (!organisationId) return;

        setLoading(true);
        try {
            const res = await axios.get(
                `${backUrl}/api/reports/department-salary/?organisation_id=${organisationId}&month=${month}&year=${year}`,
                {
                    headers: { Authorization: `Bearer ${authData?.access}` },
                }
            );

            setData(res.data);
        } catch (err) {
            console.error("Error fetching salary report:", err);
        }
        setLoading(false);
    };

    // Auto fetch when any filter changes
    useEffect(() => {
        if (organisationId) {
            fetchData();
        }
    }, [organisationId, month, year]);

    // Excel Export
    const exportExcel = () => {
        const rows = [];

        data.forEach((dep) => {
            rows.push({
                Department: dep.department_name,
                Total_Cost: dep.total_cost,
            });

            dep.employees?.forEach((emp) => {
                rows.push({
                    Department: "",
                    Employee_Name: emp.name,
                    Salary: emp.salary,
                });
            });

            rows.push({});
        });

        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Department Salary");
        XLSX.writeFile(wb, "DepartmentWisePayroll.xlsx");
    };

    const columns = [
        { title: "Department Name", dataIndex: "department_name", width: 200 },
        { title: "Total Cost", dataIndex: "total_cost", width: 150 },
    ];

    const expandedRowRender = (record) => {
        if (!record.employees || record.employees.length === 0)
            return <i>No employees found</i>;

        return (
            <Table
                dataSource={record.employees}
                pagination={false}
                size="small"
                bordered
                rowKey={(row) => row.name}
                columns={[
                    { title: "Employee", dataIndex: "name" },
                    { title: "Salary", dataIndex: "salary" },
                ]}
            />
        );
    };

    return (
        <>
            <center>
                <h5>Department Wise Payroll Report</h5>
            </center>
            <br />

            {/* Filters */}
            <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
                {/* Organisation */}
                <Select
                    style={{ width: 250 }}
                    value={organisationId}
                    placeholder="Select Organisation"
                    onChange={(v) => setOrganisationId(v)}
                >
                    {organizations.map((o) => (
                        <Option key={o.id} value={o.id}>
                            {o.name}
                        </Option>
                    ))}
                </Select>

                {/* Month */}
                <Select
                    style={{ width: 120 }}
                    value={month}
                    onChange={(v) => setMonth(v)}
                >
                    {[
                        "01", "02", "03", "04", "05", "06",
                        "07", "08", "09", "10", "11", "12",
                    ].map((m) => (
                        <Option key={m} value={m}>
                            {m}
                        </Option>
                    ))}
                </Select>

                {/* Year */}
                <Select
                    style={{ width: 120 }}
                    value={year}
                    onChange={(v) => setYear(v)}
                >
                    <Option value="2023">2023</Option>
                    <Option value="2024">2024</Option>
                    <Option value="2025">2025</Option>
                    <Option value="2026">2026</Option>
                </Select>
            </div>

            {/* Download */}
            <Button
                type="primary"
                onClick={exportExcel}
                icon={<DownloadOutlined />}
                style={{
                    marginBottom: 15,
                    backgroundColor: "#0e497b",
                    borderColor: "#0e497b",
                    color: "white",
                }}
            >
                Download Excel
            </Button>

            {/* Table */}
            {loading ? (
                <Spin size="large" />
            ) : (
                <Table
                    dataSource={data}
                    columns={columns}
                    expandable={{ expandedRowRender }}
                    rowKey={(row) => row.department_name}
                    bordered
                    size="middle"
                    components={{
                        header: {
                            cell: (props) => (
                                <th
                                    {...props}
                                    style={{
                                        backgroundColor: "#0e497b",
                                        color: "white",
                                    }}
                                >
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                />
            )}
        </>
    );
}
